import { Component } from '@angular/core';
import { Feature } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-hire-freelancers',
  template: `
    <app-bar flTrackingSection="SubnavHireFreelancers">
      <app-bar-item
        link="/post-project"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.CONTEST_POST"
        link="/contest/create.php"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="StartAContest"
      >
        Start a Contest
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.LOCAL_JOBS"
        link="/local"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="PostALocalJob"
      >
        Post a Local Job
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.SHOWCASE"
        link="/showcase"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="Showcase"
      >
        Showcase
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.SEARCH"
        link="/freelancers"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="BrowseDirectory"
      >
        Browse Directory
      </app-bar-item>
      <app-bar-item
        link="/recruiter"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="GetARecruiter"
      >
        Get a Recruiter
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.COMMUNITY"
        link="/community"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="Community"
      >
        Community
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation hire bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryHireFreelancersComponent {
  ButtonColor = ButtonColor;
  Feature = Feature;
}
